import { Box, Layer, Spinner, Text } from 'grommet'

const fullScreenLoaderStyle = {
  background: '#f5f5f5',
  margin: 'auto',
  minHeight: '100vh',
  width: '100%'
} as const

/** Full-screen loader with solid background. Use as root Suspense fallback to avoid white screen. */
export const AppLoader = () => (
  <Box align="center" justify="center" style={fullScreenLoaderStyle}>
    <Spinner height="80px" size="medium" width="80px" />
    <Text margin={{ top: 'medium' }} weight="bold">
      Loading...
    </Text>
  </Box>
)

export const Loader = () => {
  return (
    <Layer background="transparent">
      <Box align="center" alignSelf="center" direction="row" flex gap="small" justify="center" pad="large">
        <Spinner />
        <Text color="white">Loading...</Text>
      </Box>
    </Layer>
  )
}

export const FullScreenLoading = () => (
  <Box align="center" justify="center" style={fullScreenLoaderStyle}>
    <Spinner height="80px" size="medium" width="80px" />
    <Text margin={{ top: 'medium' }} weight="bold">
      Loading...
    </Text>
  </Box>
)

export const InstantLoading = () => (
  <Box align="center" justify="center" style={{ margin: 'auto' }}>
    <Spinner height={'80px'} size="5px" width={'80px'} />
    <Text weight="bold">Loading ...</Text>
  </Box>
)
